import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';

import { View } from '../View';
import Header from '../Header';
import Footer from '../Footer';

import { styleUtils } from '../../utils';

import styles from './styles';
import {renderRoutes} from "react-router-config";

const { style } = styleUtils;

const RootContainer = style(View, styles.rootContainer);
const Container = style(View, styles.container);
const Section = style(View, styles.section);
const MainContent = style(View, styles.mainContent);

const getPageName = (pathname, routes) =>
  routes.some(route => route.path === pathname) && pathname !== "/" ? pathname.replace(/\//g,'') : 'default';

const pageTitlePosition = {
  contact: 'start',
  default: 'center'
};

const showBreadCrumb = {
  contact: false,
  default: true
};

const getTitlePosition = page => pageTitlePosition[page];
const getBreadcrumbDisplay = page => showBreadCrumb[page];



class Layout extends Component {
  render() {
    const page = getPageName(this.props.location.pathname, this.props.route.routes);
    const { t, theme, step, route, history, showFooter, showHeader } = this.props;

    return (
      <ThemeProvider theme={theme}>
        <RootContainer>
          <Container>
            <Section>
              <Header
                step={step}
                title={t(`${page}.title`)}
                titlePosition={getTitlePosition(page)}
                showBreadcrumb={getBreadcrumbDisplay(page)}
                history={history}
                showTopbar={showHeader}
              />
            </Section>
            <View className="content-wrapper">
              <MainContent>
                {renderRoutes(route.routes)}
              </MainContent>
            </View>
            {showFooter && <Section>
              <Footer/>
            </Section>}
          </Container>
        </RootContainer>
      </ThemeProvider>
    );
  }
}

Layout.propTypes = {
  theme: PropTypes.object,
  step: PropTypes.number,
  showFooter: PropTypes.bool,
  showHeader: PropTypes.bool
};

Layout.defaultProps = {
  theme: {},
  step: 1,
  showFooter: false,
  showHeader: false
};

export default Layout;
